@let isMobile = _storeSvc.res().mobileLarge || _storeSvc.res().mobile || _storeSvc.res().tablet;
@let localeObj = _storeSvc.localeObj();
@let roomRate = data();
@let isRoomRateLoading = isLoading();

<app-card
  @grow
  classes="w-100 card-room-rate-card"
  [padding]="noPadding() ? 0 : 1.25"
  [marginBottom]="noMarginBottom() ? 0 : 1.5"
  [noPadding]="noPadding()"
  [noBorder]="noBorder()"
>
  <!-- --------------------------- Room Rate Card START --------------------------- -->
  <div
    class="room-rate-card d-flex"
    [class.is-mobile]="isMobile"
    [class.flex-row]="!isMobile"
    [class.align-items-center]="!isMobile"
    [class.flex-column]="isMobile"
    [class.align-items-start]="isMobile"
    [style.padding.rem]="isChild() ? 0 : 2.5"
  >
    <div class="rate-info d-flex flex-column align-items-start col-12 col-md" [class.p-0]="noPadding()">
      @if (isMobile && isRoomRateLoading) {
        <div class="rate-name-skeleton w-100">
          <app-skeleton-loader-item
            [count]="1"
            [width]="'100%'"
            [fullWidth]="true"
            [height]="'2rem'"
            [borderRadius]="'4px'"
            [marginBottom]="'0'"
          />
        </div>
      } @else {
        <h3 class="rate-name-container d-inline-flex align-items-center gap-1 mb-0" [class.lh-1]="isMobile">
          @let rateName =
            roomRate?.isPreLoginOffer
              ? localeObj?.tf_2_RoomList_MembersRate_Label + ' - ' + (roomRate?.offerName || roomRate?.name)
              : roomRate?.offerName || roomRate?.name;

          <span class="rate-name" [class.global-line-height-26]="!isMobile" [innerHTML]="rateName | safeHtml"></span>

          @if (isMobile) {
            <app-button
              [id]="'rate-details-link-' + roomRate.code"
              variant="icon"
              iconDisplay="icon-only"
              icon="fa fa-regular fa-info-circle"
              [classes]="'icon-button fa-xs p-0 ms-2 lh-24'"
              [label]="localeObj?.tf_2_RoomList_viewofferDetails_link"
              (onClickEvent)="openRoomRateDetails()"
            />
          }
        </h3>
      }

      @if (!isMobile) {
        <p class="rate-description mb-0" [innerHTML]="roomRate.description | safeHtml"></p>
      }

      @if (!isMobile) {
        <div class="rate-details-button">
          <app-button
            variant="link"
            [label]="localeObj?.tf_2_RoomList_viewofferDetails_link"
            (onClickEvent)="openRoomRateDetails()"
          />
        </div>
      }
    </div>

    <div class="rate-price-action-container d-flex">
      <div class="rate-price-details">
        @let pricingData = pricing();
        @let pricingType =
          _storeSvc.propInfo()?.showAverageNightlyRate
            ? localeObj?.tf_2_RoomList_roomDetails_perNight
            : localeObj?.tf_2_RoomList_roomDetails_perStay;

        @let discountedPrice =
          _storeSvc.getDiscountedRatePlanPrice(
            roomRate || {},
            _storeSvc.currConf()?.code,
            _shoppingCartSvc.showTaxesInDisplayPrice()
          );

        @let avgPrice =
          _storeSvc.getAvgRatePlanPrice(
            roomRate || {},
            _storeSvc.currConf()?.code,
            _shoppingCartSvc.showTaxesInDisplayPrice()
          );

        <div class="from-price-row mb-1">
          @if (isRoomRateLoading) {
            <div class="from-price-row-skeleton w-100">
              <app-skeleton-loader-item
                [count]="1"
                [width]="'65%'"
                [fullWidth]="true"
                [height]="'1rem'"
                [borderRadius]="'4px'"
                [marginBottom]="'0'"
              />
            </div>
          } @else {
            @if (
              pricingData.hasAvgRate &&
              (pricingData.hasUpsellPrice || (!pricingData.isFullComp && !pricingData.isPartialComp))
            ) {
              <span class="sr-only" [innerHTML]="localeObj.tf_3_MultiRoom_checkinSummery_ADA_Original_price"></span>
            }
            @if (!pricingData.isFullComp && !pricingData.isPartialComp) {
              <span class="from-price-label" [innerHTML]="localeObj?.tf_2_RoomList_roomDetails_fromPrice"></span>
            }
            @if (discountedPrice > 0 && avgPrice > discountedPrice) {
              <del class="from-price-value" [innerHTML]="_storeSvc.priceFormat(avgPrice)"></del>
            }
          }
        </div>

        <div class="actual-price-row d-flex align-items-center flex-wrap gap-1 mb-1">
          @if (isRoomRateLoading) {
            <div class="actual-price-row-skeleton w-100">
              <app-skeleton-loader-item
                [count]="1"
                [width]="'100%'"
                [fullWidth]="true"
                [height]="'1.75rem'"
                [borderRadius]="'4px'"
                [marginBottom]="'0'"
              />
            </div>
          } @else {
            <span class="sr-only" [innerHTML]="localeObj?.tf_3_MultiRoom_checkinSummery_ADA_Current_price"></span>
            @if (pricingData?.isFullComp || pricingData?.isPartialComp) {
              <img
                class="complimentary-icon"
                [src]="_storeSvc.complimentaryIcon()"
                [alt]="localeObj?.tf_2_RoomList_Complimentary_text"
              />
            }
            @if (pricingData?.isFullComp) {
              <span class="large-font-size" [innerHTML]="localeObj?.tf_2_RoomList_Complimentary_text"> </span>
            } @else if (pricingData?.isPartialComp) {
              <span class="default-font-size pb-3" [innerHTML]="localeObj?.tf_2_RoomList_availableComplimentaryNight_text">
              </span>
            } @else {
              <span
                class="actual-price-value price-color"
                [innerHTML]="_storeSvc.priceFormat(discountedPrice || avgPrice)"
              >
              </span>
              <span class="pricing-type" [innerHTML]="pricingType"> </span>
            }
          }
        </div>

        <div class="tax-msg-row">
          @if (isRoomRateLoading) {
            <div class="tax-msg-row-skeleton w-100">
              <app-skeleton-loader-item
                [count]="1"
                [width]="'75%'"
                [fullWidth]="true"
                [height]="'1rem'"
                [borderRadius]="'4px'"
                [marginBottom]="'0'"
              />
            </div>
          } @else {
            <span class="tax-msg-label" [innerHTML]="pricingData.taxDisplay | safeHtml"></span>
          }
        </div>

        @let dprTagLine = roomRate?.dprTagLine;
        @if (showDPRMessage() && isRoomRateLoading) {
          <div class="dpr-row-skeleton w-100">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'80%'"
              [fullWidth]="true"
              [height]="'1rem'"
              [borderRadius]="'4px'"
              [marginBottom]="'0'"
            />
          </div>
        } @else if (showDPRMessage() && dprTagLine) {
          <div class="dpr-row mt-12">
            <app-tag tagId="dpr" variant="success" icon="fa fa-badge-percent" [label]="dprTagLine" />
          </div>
        }
      </div>

      <div class="rate-action" [class.w-50]="isMobile && isRoomRateLoading">
        @if (isRoomRateLoading) {
          <div class="rate-action-skeleton">
            <app-skeleton-loader-item
              [count]="1"
              [width]="'100%'"
              [fullWidth]="true"
              [height]="'2.5rem'"
              [borderRadius]="'var(--button-border-radius)'"
              [marginBottom]="'0'"
            />
          </div>
        } @else {
          <app-button
            variant="primary"
            [label]="isMobile ? localeObj?.tf_2_RoomList_select : localeObj?.tf_2_RoomList_selectRate"
            (onClickEvent)="selectRate()"
          />
        }
      </div>
    </div>
  </div>
  <!-- ---------------------------- Room Rate Card END ---------------------------- -->
</app-card>

<!-- ---------------------- Room Rate Details START ----------------------- -->
<ng-template #roomRateDetailsContent>
  <div class="s-pb-32">
    <app-nav-tabs
      [tabs]="roomRateDetailsNavTabs()"
      [activeTab]="roomRateDetailsActiveTab()"
      (onTabChange)="roomRateDetailsActiveTab.set($event)"
    />
  </div>
  @if (roomRateDetailsActiveTab() === 'RATE_DETAILS') {
    <div class="s-pb-32">
      <span [innerHTML]="roomRate?.description | safeHtml"></span>
    </div>
    <div>
      <h5 class="s-mb-12" [innerHTML]="localeObj?.tf_04_Checkout_payment_cancellation_policies"></h5>
      <span [innerHTML]="roomRate?.policyDetails?.policies[0]?.cancellationPolicy | safeHtml"></span>
    </div>
  } @else {
    <app-price-breakdown [ratePlan]="roomRate" />
  }
</ng-template>

<!-- ----------------------- Room Rate Details END ------------------------ -->
